import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'tripReport',
  initialState: { items: [] },
  reducers: {
    setItems(state, action) { state.items = action.payload; },
  }
});

export { actions as tripReportActions };
export { reducer as tripReportReducer };
